import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
import toast from '../../../core/toast'; 

const Url='/book-issue-return';
const backUrl='/library'+Url;
const menuUrl='/getallbookcategory';
const saveUrl='book-returned';

 

class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            member_type:'student', 
            book_name:'',
            bookList:[],
            issue_date:'',
            return_date:'',
            status:1, 
            memberList:[],
            member_name:'',
            no_days:15,
            returned_date:'',
            preloader:this.props.match.params.id?true:false,
            pagetitle:this.props.match.params.id?'Edit':'New'
        };
        this.validator = new SimpleReactValidator();
    }


    componentDidMount(){

        viewData(menuUrl).then((res)=>{
            if(res.data.status===200){
                let datam =res.data.data;
                this.setState({bookCategoryData:datam});
                if(this.props.match.params.id){
                    viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                        if(res.data.status===200){
                            let data=res.data.data;
                            this.setState({
                                book_id:data.book_id?data.book_id:'', 
                                member_id:data.member_id?data.member_id:'', 
                                book_name:data.book_name?data.book_name:'', 
                                member_type:data.member_type?data.member_type:'', 
                                member_name:data.member_name?data.member_name:'', 
                                issue_date:data.issue_date?moment(data.issue_date).format('DD/MM/YYYY'):'', 
                                return_date:data.return_date?data.return_date:'', 
                                status:data.status, 
                                preloader:false, 
                            });
                        }
                    });
                }
            }
        });
    }

    submitForm=()=>{
        if( this.validator.allValid() ){
            let params={
                returned_date: moment(this.state.returned_date).format('DD-MM-YYYY'),
                member_type:this.state.member_type
            }; 
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            processData(saveUrl+para,params).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.msg?res.data.msg:'Please enter required feilds...';  
                    this.setState({error_status:true,preloader:false});
                    toast.info(msg);
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    handleEntryDate=(date)=>{
        this.setState({returned_date: date});
    } 
    
    render() {
        const {pagetitle,preloader,book_name,issue_date,member_name,member_type,return_date,returned_date} = this.state;

        const role=permissionCheck('book',pagetitle);
        if(!role)
            return <Nopermission/>;
        
        const book_nameValid = this.validator.message('Book Name',book_name, 'required');
        const issue_dateValid = this.validator.message('issue_date',issue_date, 'required');
        const member_nameValid = this.validator.message('Member Name',member_name, 'required');
        const member_typeValid = this.validator.message('Member Type',member_type, 'required'); 
        const return_dateValid = this.validator.message('Return Date',return_date, 'required'); 
        const returned_dateValid = this.validator.message('Returned Date',returned_date, 'required'); 
 
        return (
            <div id="page_content_inner" className="uk-width-medium-6-10 uk-container-center">
                <h3 className="heading_b uk-margin-bottom"> Book Return</h3>
                <div className="md-card">
                    <div className="md-card-content small-padding">
                        <div className="uk-grid">
                            <div className="uk-width-medium-1-2"> 
                                <div className={ `md-input-wrapper ${member_type ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Member Type">Member Type<span className="req">*</span></label>
                                    <input type="text" name="member_type" value={member_type}  className={ `md-input ${member_typeValid ?'md-input-danger':''}`} /> 
                                    {member_typeValid} 
                                </div> 
                            </div>
                            
                            <div className="uk-width-medium-1-2"> 
                                <div className={ `md-input-wrapper ${member_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Member Name">Member Name<span className="req">*</span></label>
                                    <input type="text" name="member_name" value={member_name}  className={ `md-input ${member_nameValid ?'md-input-danger':''}`} /> 
                                    {member_nameValid} 
                                </div> 
                            </div> 
                             
                        </div> 

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-2"> 
                                <div className={ `md-input-wrapper ${book_name ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Book Name">Book Name<span className="req">*</span></label>
                                    <input type="text" name="book_name" value={book_name}  className={ `md-input ${book_nameValid ?'md-input-danger':''}`} /> 
                                    {book_nameValid} 
                                </div> 
                            </div>   
                            <div className="uk-width-medium-1-2"> 
                                <div className={ `md-input-wrapper ${returned_date ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Returned Date">Returned Date<span className="req">*</span></label>
                                    <DatePicker selected={returned_date} dateFormat="DD/MM/YYYY" className="datepicker md-input" onChange={this.handleEntryDate} />
                                    {returned_dateValid} 
                                </div>
                            </div> 
                        </div>

                        <div className="uk-grid">
                            <div className="uk-width-medium-1-2"> 
                                <div className={ `md-input-wrapper ${issue_date ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Book Issue Date">Book Issue Date<span className="req">*</span></label>
                                    <input type="text" name="issue_date" value={issue_date}  className={ `md-input ${issue_dateValid ?'md-input-danger':''}`} /> 
                                    {issue_dateValid} 
                                </div> 
                            </div> 
                            <div className="uk-width-medium-1-2"> 
                                <div className={ `md-input-wrapper ${return_date ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="Book Return Date">Book Return Date<span className="req">*</span></label>
                                    <input type="text" name="return_date" value={return_date}  className={ `md-input ${return_dateValid ?'md-input-danger':''}`} /> 
                                    {return_dateValid} 
                                </div>
                            </div>   
                        </div>
                        
                        <div className="uk-grid">
                            <div className="uk-width-1-1 btn-right-align">
                                <Link to={backUrl} className="md-btn md-btn-small md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                <button type="button" onClick={this.submitForm} className="md-btn md-btn-small md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Library/BookIssueReturn/returnBook.js